import { dashboardProfileMock } from "@/data/dashboardProfileMockData";

/*
 * Аватар вошедшего — ОДИН на шапку и окно ассистента.
 *
 * Раньше шапка подставляла портрет из `dashboardProfileMock`, а ассистент брал
 * `user.avatar` как есть. У `superadmin` он пустой (`/auth/me` не отдаёт ни
 * фото, ни `personId` — учётка не привязана к сотруднику), и в шапке стоял
 * портрет, а в ленте ассистента — буква «s». Выбор теперь здесь, и места
 * разойтись не могут.
 *
 * `superadmin` — ВСЕГДА портрет акима: решение пользователя от 01.10.2026,
 * панель показывается от имени руководителя области. Остальным — своё фото,
 * если есть, иначе тот же портрет, как шапка делала и раньше.
 */
export function userAvatar(user: { username: string; avatar: string } | null | undefined): string {
  if (!user || user.username === "superadmin") return dashboardProfileMock.avatar;
  return user.avatar || dashboardProfileMock.avatar;
}
